import ClientList from "../Views/Client/ClientList.vue";
import ClientCreate from "../Views/Client/ClientCreate.vue";
import ClientEdit from "../Views/Client/ClientEdit.vue";
import ClientShow from "../Views/Client/ClientShow.vue";
import {MODULES} from "../Constants/modules.js";

export const clientRoutes = [
    {
        path: "/clients/edit/:id",
        name: "clients.edit",
        component: ClientEdit,
        meta: {
            module: MODULES.CLIENTS,
            menu: {
                parent: 'clients',
                child: null
            },
            breadcrumb: {
                title: "Contacts",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Tous les contacts",
                            link: {name: 'clients.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/clients/create",
        name: "clients.create",
        component: ClientCreate,
        meta: {
            module: MODULES.CLIENTS,
            menu: {
                parent: 'clients',
                child: null
            },
            breadcrumb: {
                title: "Contacts",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Tous les contacts",
                            link: {name: 'clients.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/clients/:id",
        name: "clients.show",
        component: ClientShow,
        meta: {
            module: MODULES.CLIENTS,
            menu: {
                parent: 'clients',
                child: null
            },
            breadcrumb: {
                title: "Contacts",
                nav: {
                    all: {
                        active: "Fiche contact",
                        inactive: [{
                            title: "Tous les contacts",
                            link: {name: 'clients.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/clients",
        name: "clients.list",
        component: ClientList,
        meta: {
            module: MODULES.CLIENTS,
            menu: {
                parent: 'clients',
                child: null
            },
            breadcrumb: {
                title: "Contacts",
                nav: {
                    all: {
                        active: "Tous les contacts",
                        inactive: []
                    }
                }
            }
        },
    }
];
